export enum DebitOrCredit {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}

export enum CardType {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
  PREPAID = "PREPAID",
}

export enum PaymentMethodType {
  CARD = "CARD",
  ACH = "ACH",
  APPLE_PAY = "APPLE_PAY",
  /** Paid over time with Affirm, chosen on a Stripe card reader. */
  AFFIRM = "AFFIRM",
}

export enum PaymentMedium {
  POS = "POS",
  VIRTUAL_TERMINAL = "VIRTUAL_TERMINAL",
  PAYMENT_LINK = "PAYMENT_LINK",
  SUBSCRIPTION = "SUBSCRIPTION",
  CASH = "CASH",
  CHECK = "CHECK",
  CARE_CREDIT = "CARE_CREDIT",
  PATIENT_CREDIT = "PATIENT_CREDIT",
  PAYMENT_PLAN = "PAYMENT_PLAN",
  SAVED_PAYMENT_METHOD = "SAVED_PAYMENT_METHOD",
  MEMBERSHIP = "MEMBERSHIP",
  EMBEDDED_TERMINAL = "EMBEDDED_TERMINAL",
  GIFT_CARD = "GIFT_CARD",
  LOYALTY_POINTS = "LOYALTY_POINTS",
}

export enum PaymentStatus {
  CANCELED = "CANCELED",
  CREATED = "CREATED",
  FAILED = "FAILED",
  IN_REVIEW = "IN_REVIEW",
  PRESENTING = "PRESENTING",
  PROCESSING = "PROCESSING",
  SUCCEEDED = "SUCCEEDED",
}

export enum RefundState {
  NONE = "NONE",
  PROCESSING = "PROCESSING",
  PARTIAL = "PARTIAL",
  FULL = "FULL",
  FAILED = "FAILED",
}

export enum PaymentOption {
  INVOICE = "INVOICE",
  PAYMENT_PLAN = "PAYMENT_PLAN",
  CASH = "CASH",
  CHECK = "CHECK",
  PATIENT_CREDIT = "PATIENT_CREDIT",
  CARE_CREDIT = "CARE_CREDIT",
  GIFT_CARD = "GIFT_CARD",
  LOYALTY_POINTS = "LOYALTY_POINTS",
}
